import {
  GetInTouchSection,
  GetInTouchSectionProps,
  inputTextType,
  inputType,
  localeType,
  useCaseType,
} from '@rimactechnology/rimac-ui-lib';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';

import {
  ContactFormDataInput,
  FormQuery,
  useSendContactFormMutation,
} from '@/api';

export const Form = ({ data }: { data: FormQuery }) => {
  const router = useRouter();
  const { locale } = router;

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sendForm] = useSendContactFormMutation();

  const onSubmit: SubmitHandler<ContactFormDataInput> = async (data) => {
    window.grecaptcha.enterprise.ready(async () => {
      setLoading(true);
      await window.grecaptcha.enterprise.execute(
        '6LdYHeQrAAAAAAB5MH6JPeb5KFBSV02Gnjk3LMyO',
        { action: 'LOGIN' },
      );
      await sendForm({ variables: { data } });
      setSuccess(true);
    });
  };

  const formData = data?.getInTouch?.data?.attributes;

  const formProps: GetInTouchSectionProps = {
    title: formData?.title || '',
    descriptionFirstLine: formData?.firstLine || '',
    descriptionSecondLine: formData?.secondLine || '',
    onSubmit,
    loading,
    success,
    setLoading: () => setLoading(!loading),
    setSuccess: () => setSuccess(!success),
    useCase: 'technology' as useCaseType,
    inputs: (formData?.options || []).map((input) => ({
      value: input?.value as inputTextType,
      label: input?.label || '',
      isFullWidth: !!input?.isFullWidth,
      type: input?.type as inputType,
    })),
    buttonLabel: formData?.button || '',
    checkbox: {
      labelBefore: formData?.checkBox?.labelBefore || '',
      labelLink: formData?.checkBox?.labelLink || '',
      areaLabel: formData?.checkBox?.areaLabel || '',
      path: formData?.checkBox?.path || '',
    },
    locale: locale as localeType,
    modal: {
      title: formData?.modal?.title || '',
      description: formData?.modal?.description || '',
    },
  };

  return (
    <>
      <Script
        src="https://www.google.com/recaptcha/enterprise.js?render=6LdYHeQrAAAAAAB5MH6JPeb5KFBSV02Gnjk3LMyO"
        strategy="lazyOnload"
      />
      <GetInTouchSection {...formProps} />
    </>
  );
};
